import { SET_USER } from '../actions/Notification';

const initialState = {
  user: false, // Set initial state to false
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state; // Make sure to return the state for any unhandled action
  }
};

export default notificationReducer;
